import create from 'zustand';

import { VoiceOverScript } from 'utils/experience-script/getVoiceOverScript';

export interface ScriptStoreType {
  script: VoiceOverScript;
  setScript: (script: VoiceOverScript) => void;
  reportMentioned: boolean;
  setReportMentioned: (reportMentioned: boolean) => void;
}

const useScriptStore = create<ScriptStoreType>(set => ({
  script: [],
  setScript: script => set({ script }),
  reportMentioned: false,
  setReportMentioned: reportMentioned => set({ reportMentioned }),
}));

export default useScriptStore;
